export const CHAT_FORM_PLACEHOLDER = "Ask Mindtrip"
export const ORG_CHAT_FORM_PLACEHOLDER = "Ask anything"

// Hash table to indicate whether a call to HotelAvailability endpoint is in progress.
// Used mostly on the chat page as multiple compoenents are calling the same endpoint.
export const hotelAvailabilityFetchStatuses = {} as { [key: string]: string }
